import { getCandidateName } from './candidateDisplay'
import type { SpareCandidate } from './types'

/**
 * Comma-separated display names for the players an availability request is
 * about, shown on the message sheet/modal so the sender can confirm who they're
 * requesting before posting.
 *
 * Ordered by the candidate list, NOT by the order ids were selected, so the
 * same set of players always reads the same way. Ids with no matching candidate
 * (or whose candidate has no usable name) are skipped rather than rendering a
 * blank entry between two commas.
 */
export const getSelectedCandidateNames = (
  candidates: SpareCandidate[],
  selectedIds: string[]
): string => {
  const selected = new Set(selectedIds)
  return candidates
    .filter((c) => selected.has(c.id))
    .map(getCandidateName)
    .filter(Boolean)
    .join(', ')
}
